import { Dialog } from "vant";
const tab_user = () =>
  import(/* webpackChunkName: "tabbar-user" */ "@/views/user/tabbar-user");
const UserCollect = () =>
  import(/* webpackChunkName: "user-collect" */ "@/views/user/module-collect/");
const UserTeam = () =>
  import(/* webpackChunkName: "user-team" */ "@/views/user/module-team/");
const UserInvitation = () =>
  import(
    /* webpackChunkName: "user-invitation" */ "@/views/user/module-invitation/"
  );
const UserAddress = () =>
  import(/* webpackChunkName: "user-address" */ "@/views/user/module-address/");
const UserAddressEdit = () =>
  import(
    /* webpackChunkName: "user-addressEdit" */ "@/views/user/module-address-edit/"
  );
const UserAutonym = () =>
  import(/* webpackChunkName: "user-autonym" */ "@/views/user/module-autonym/");
const UserAutonymEdit = () =>
  import(
    /* webpackChunkName: "user-autonymEdit" */ "@/views/user/module-autonym-edit/"
  );
const UserServer = () =>
  import(/* webpackChunkName: "user-server" */ "@/views/user/module-server/");

const userInfo = () =>
  import(/* webpackChunkName: "userInfo" */ "@/views/user/userInfo/index");

const changePW = () =>
  import(/* webpackChunkName: "userInfo" */ "@/views/user/userInfo/changePW");
const UserInformation = () =>
  import(
    /* webpackChunkName: "user-information" */ "@/views/user/user-information-set/"
  );
const UserInfo_SetBg = () =>
  import(
    /* webpackChunkName: "user-info-setBg" */ "@/views/user/user-information-set/set-bg/"
  );
const UserInfo_SetMobile = () =>
  import(
    /* webpackChunkName: "user-info-setMobile" */ "@/views/user/user-information-set/set-mobile/"
  );
const UserInfo_SetNickname = () =>
  import(
    /* webpackChunkName: "user-info-setNickname" */ "@/views/user/user-information-set/set-nickname/"
  );
const UserInfo_SetPassword = () =>
  import(
    /* webpackChunkName: "user-info-setPassword" */ "@/views/user/user-information-set/set-password/"
  );

const UserOrderEntityList = () =>
  import(
    /* webpackChunkName: "order-entity-list" */ "@/views/user/order-entity-list/"
  );
const UserOrderEleList = () =>
  import(
    /* webpackChunkName: "order-ele-list" */ "@/views/user/order-ele-list/"
  );
const UserOrderBulkList = () =>
  import(
    /* webpackChunkName: "order-ele-list" */ "@/views/user/order-bulk-list/"
  );
const UserRefundList = () =>
  import(
    /* webpackChunkName: "user-refund-list" */ "@/views/user/refund-list/"
  );
const User_WriteRefund_jd = () =>
  import(
    /* webpackChunkName: "user-writeRefund_jd" */ "@/views/user/refund-list/refund-write-jd/index.vue"
  );
const User_WriteRefund_sbz = () =>
  import(
    /* webpackChunkName: "user-writeRefund_sbz" */ "@/views/user/refund-list/refund-write-sbz/index.vue"
  );
const User_Refund_Detail = () =>
  import(
    /* webpackChunkName: "user-refund-detail" */ "@/views/user/refund-list/refund-detail/index.vue"
  );
const User_Refund_Progress = () =>
  import(
    /* webpackChunkName: "user-refund-progress" */ "@/views/user/refund-list/refund-progress/index.vue"
  );
const User_Refund_Delevery = () =>
  import(
    /* webpackChunkName: "user-refund-detail" */ "@/views/user/refund-list/refund-develery/index.vue"
  );
const UserOrderDetail = () =>
  import(
    /* webpackChunkName: "user-order-detail" */ "@/views/user/order-detail/index.vue"
  );
const UserOrderLogistics = () =>
  import(
    /* webpackChunkName: "user-order-logistics" */ "@/views/user/order-logistics/index.vue"
  );
// const UserOrderSignature = () => import(/* webpackChunkName: "user-order-logistics" */ '@/views/user/order-signature/index.vue');
const UserOrderSignature = () =>
  import(
    /* webpackChunkName: "user-order-logistics" */ "@/views/user/order-signature/oIndex.vue"
  );
const UserOrderSuccess = () =>
  import(
    /* webpackChunkName: "user-order-logistics" */ "@/views/user/order-signature/success.vue"
  );

const UserOrdersetName = () =>
  import(
    /* webpackChunkName: "user-order-logistics" */ "@/views/user/order-signature/setName.vue"
  );
const UserOrdercheck = () =>
  import(
    /* webpackChunkName: "user-order-logistics" */ "@/views/user/order-signature/check.vue"
  );
const UserOrderSignatureStatus = () =>
  import(
    /* webpackChunkName: "user-order-logistics" */ "@/views/user/order-signature/status.vue"
  );
const AccountDetail = () =>
  import(
    /* webpackChunkName: "account-details" */ "@/views/user/account-detail/index.vue"
  );
const Coupon = () =>
  import(/* webpackChunkName: "coupon" */ "@/views/user/coupon/index.vue");
const CouponSelect = () =>
  import(/* webpackChunkName: "coupon" */ "@/views/user/coupon/select.vue");
const Tabbar = () =>
  import(/* webpackChunkName: "Tabbar" */ "@/vue/components/Tabbar/");
const applyInvoice = () =>
  import(
    /* webpackChunkName: "coupon" */ "@/views/user/apply-invoice/index.vue"
  );
const applyInvoiceResult = () =>
  import(
    /* webpackChunkName: "coupon" */ "@/views/user/apply-invoice/result.vue"
  );
const pointList = () =>
  import(/* webpackChunkName: "pointList" */ "@/views/user/points/list.vue");
const pointDetail = () =>
  import(
    /* webpackChunkName: "pointDetail" */ "@/views/user/points/detail.vue"
  );
const flashSale = () =>
  import(
    /* webpackChunkName: "flash-sale" */ "@/views/user/flash-sale/index.vue"
  );
const flashSaleRule = () =>
  import(
    /* webpackChunkName: "flash-sale" */ "@/views/user/flash-sale/rule.vue"
  );
const flashSaleDetail = () =>
  import(
    /* webpackChunkName: "flash-sale" */ "@/views/user/flash-sale/detail.vue"
  );
const basicCustomer = () =>
  import(
    /* webpackChunkName: "basic-customer" */ "@/vue/components/customer-service/customer.vue"
  );
export default [
  {
    path: "/user",
    name: "user",
    meta: { title: "个人中心" },
    components: { default: tab_user, tabbar: Tabbar }
  },
  {
    path: "/userInfo",
    name: "userInfo",
    meta: { title: "用户信息" },
    components: { default: userInfo }
  },
  {
    path: "/changePW",
    name: "changePW",
    meta: { title: "修改密码" },
    components: { default: changePW }
  },
  {
    path: "/user/collect",
    name: "collect",
    meta: { title: "我的收藏" },
    component: UserCollect
  },
  {
    path: "/user/team",
    name: "team",
    meta: { title: "我的团队" },
    component: UserTeam
  },
  {
    path: "/user/invitation",
    name: "invitation",
    meta: { title: "邀请" },
    component: UserInvitation
  },
  {
    path: "/user/address",
    name: "address",
    meta: { title: "收货地址" },
    component: UserAddress
  },
  {
    path: "/user/address/edit/:addressId?",
    name: "address-edit",
    meta: { title: "编辑地址" },
    props: true,
    component: UserAddressEdit
  },
  {
    path: "/user/autonym",
    name: "autonym",
    meta: { title: "实名认证" },
    component: UserAutonym
  },
  {
    path: "/user/autonym/edit",
    name: "autonym-edit",
    meta: { title: "实名认证" },
    component: UserAutonymEdit
  },
  {
    path: "/user/server",
    name: "user-server",
    meta: { title: "客服" },
    component: UserServer
  },
  {
    path: "/user/information",
    name: "user-information",
    meta: {
      login: true,
      title: "个人设置"
    },
    component: UserInformation
  },
  {
    path: "/user/information/setbg",
    name: "user-info-setbg",
    meta: { title: "设置背景" },
    component: UserInfo_SetBg
  },
  {
    path: "/user/information/setMobile",
    name: "user-info-setMobile",
    meta: { title: "设置手机号" },
    component: UserInfo_SetMobile
  },
  {
    path: "/user/information/setNickname",
    name: "user-info-setNickname",
    meta: { title: "设置昵称" },
    component: UserInfo_SetNickname
  },
  {
    path: "/user/information/setPassword",
    name: "user-info-setPassword",
    meta: { title: "设置密码" },
    component: UserInfo_SetPassword
  },
  {
    path: "/user/order/list/:active",
    name: "user-order-list",
    meta: { title: "我的订单" },
    props: true,
    component: UserOrderEntityList
  },
  {
    path: "/user/orderBulk/list/:active",
    name: "user-order-bulk-list",
    meta: { title: "批量订单" },
    props: true,
    component: UserOrderBulkList
  },
  {
    path: "/user/orderEle/list/:active",
    name: "user-order-ele-list",
    meta: { title: "电子订单" },
    props: true,
    component: UserOrderEleList
  },
  {
    path: "/user/order/detail/:id",
    name: "user-order-detail",
    meta: { title: "订单详情" },
    props: true,
    component: UserOrderDetail
  },
  {
    path: "/user/refund/list",
    name: "user-refund-list",
    meta: { title: "退款列表" },
    component: UserRefundList
  },
  {
    path: "/user/refund/writejd/:id",
    name: "user-refund-writejd",
    meta: { title: "申请退款" },
    component: User_WriteRefund_jd
  },
  {
    path: "/user/refund/writesbz/:id",
    name: "user-refund-writesbz",
    meta: { title: "申请退款" },
    component: User_WriteRefund_sbz
  },
  {
    path: "/user/refund/detail/:id",
    name: "user-refund-detail",
    meta: { title: "退款详情" },
    component: User_Refund_Detail
  },
  {
    path: "/user/refund/progress/:id",
    name: "user-refund-progress",
    meta: { title: "退款进度" },
    component: User_Refund_Progress
  },
  {
    path: "/user/refund/delevery/:order_product_id?/:workorder_id?",
    name: "user-refund-delevery",
    meta: { title: "退货物流" },
    component: User_Refund_Delevery
  },
  {
    path: "/user/order/logistics/:order_id",
    name: "user-order-logistics",
    meta: { title: "物流详情" },
    component: UserOrderLogistics
  },
  {
    path: "/user/order/check",
    name: "user-order-check",
    meta: { title: "订单确认" },
    component: UserOrdercheck
  },
  {
    path: "/user/order/setName",
    name: "user-order-setName",
    meta: { title: "设置姓名" },
    component: UserOrdersetName
  },
  {
    path: "/user/order/signature",
    name: "user-order-signature",
    meta: { title: "电子签名" },
    component: UserOrderSignature
  },
  {
    path: "/user/order/success",
    name: "user-order-successs",
    meta: { title: "签名成功" },
    component: UserOrderSuccess
  },
  {
    path: "/user/order/signature/status",
    name: "user-order-signature-status",
    meta: { title: "签名状态" },
    component: UserOrderSignatureStatus
  },
  {
    path: "/user/account/detail",
    name: "account-detail",
    meta: { title: "账户明细" },
    component: AccountDetail
  },
  {
    path: "/user/coupon",
    name: "coupon",
    meta: { title: "我的优惠券" },
    component: Coupon
  },
  {
    path: "/user/coupon/select",
    name: "coupon-select",
    meta: { title: "选择优惠券" },
    component: CouponSelect
  },
  {
    path: "/user/apply/invoice/:id",
    name: "apply-invoice",
    meta: { title: "申请发票" },
    component: applyInvoice
  },
  {
    path: "/user/apply/invoice/result/:id",
    name: "apply-invoice-result",
    meta: { title: "发票结果" },
    component: applyInvoiceResult
  },
  {
    path: "/user/point/list",
    name: "point-list",
    meta: {
      keepAlive: true,
      title: "我的积分"
    },
    component: pointList
  },
  {
    path: "/user/point/detail",
    name: "point-detail",
    meta: { title: "积分详情" },
    component: pointDetail
  },
  {
    path: "/flash-sale",
    name: "flash-sale",
    meta: { title: "限时抢购" },
    component: flashSale
  },
  {
    path: "/flash-sale/rule",
    name: "flash-sale-rule",
    meta: { title: "抢购规则" },
    component: flashSaleRule
  },
  {
    path: "/flash-sale/detail",
    name: "flash-sale-detail",
    meta: { title: "抢购详情" },
    component: flashSaleDetail
  },
  {
    path: "/basic/customer",
    name: "customer",
    meta: { title: "在线客服" },
    component: basicCustomer
  }
];
